import TextareaAutogrow from 'stimulus-textarea-autogrow'

export default class extends TextareaAutogrow {
  connect () {
    super.connect()
    this.tArea = this.initIntersectionObserver()
    document.addEventListener('turbo:morph', this.reconnect.bind(this))
  }

  disconnect () {
    this.tArae = undefined
  }

  initIntersectionObserver () {
    new window.IntersectionObserver(this.handleIntersection).observe(this.element)
  }

  reconnect () {
    this.disconnect()
    this.connect()
  }

  handleIntersection = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.autogrow()
      }
    })
  }
}
